<template>
  <div class="container page" style="background-color: #f4f4f4;">
    <van-nav-bar title="视频观看" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video id="my-video" class="video-js"></video>
    </div>
    <a @click="back('recharge')" v-if="remain_watch_times==0" class="btn">
      <p>当前播放剩余 0 次</p>
      <p>点击获取VIP无限播放次数</p>
      <div class="flex flex-item flex-content icon"><van-icon name="down" color="#EC6272" size="20"
          style="transform: rotate(-90deg);" /></div>
    </a>
    <div class="movie-descript">
      <p>{{ this.videoInfo.vod_name }}</p>
      <!-- <span>{{ this.videoInfo.count }}{{ $t("video.num_play") }}</span> -->
    </div>
    <div class="movie-content">
      <div class="movie-body">
        <div class="movie-title">
          猜你喜欢
        </div>
      </div>
      <div class="videos">
        <div class="videoItem" v-for="item in moreVideoInfo" :key="item.id" @click="toPlayVideo(item)">
          <div class="img"><img :src="$baseURL + item.cover" class="img"></div>
          <div class="info">
            <h3>{{ item.title }}</h3>
            <p>评分：{{ item.fraction }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: {},
      player: null,
      is_play: false,
      times: null,
      remain_watch_times:0
    };
  },
  methods: {
    back(type) {
      this.$router.go(-1);
      if (type == 'recharge') {
        setTimeout(() => {
          this.$dialog.alert({
            message: '充值通道请联系在线客服进行充值',
            className: 'noVw'
          });
        }, 300);
      }
    },
    getVideoInfo() {
      this.$http({
        method: "get",
        data: { id: this.$route.query.id },
        url: "video_get_info",
      }).then((res) => {
        if (res.code == 400) {
          this.remain_watch_times=0
          this.$dialog.alert({
            message: res.msg,
            className: 'noVw'
          });
          this.player.dispose();
          this.player = null;
          return;
        }
        this.remain_watch_times=1
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.$baseURL+this.videoInfo.vod_pic;
        let videos = document.getElementById("my-video");

        videos.poster = this.cover;
        this.getVideo();
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "?id=" + id });
        location.reload();
      }
    },
    getMoreVideoItem() {
      this.$http({
        method: "get",
        url: "video_get_more_item",
      }).then((res) => {
        this.moreVideoInfo = res.data;
      });
    },
    getVideo() {
      // this.player = videojs("my-video",  {
      //   height:"200px",
      //   preload: "auto", // 预加载
      //   controls: true,  // 显示播放的控件
      //   multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
      // });
      this.player.src([
        {
          src: this.nowPlayVideoUrl,
          type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
        },
      ]);
      this.player.poster(this.cover);

    },
    deductWatchCount() {
      this.$http({
        method: "get",
        url: "deductWatchCount",
      });
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            localStorage.clear();
            this.$router.push({ path: "/Login" });
          } else {
            if (this.$store.getters.getBaseInfo.isplay == 1) {
              this.getVideoInfo();
              this.getMoreVideoItem();
              // if(this.userInfo.money <= "0.00"){
              //   this.$toast(this.$t("video.buy"));
              //   this.$router.push({path:'/Home'})
              // }
            } else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.player = videojs(
        "my-video",
        {
          height: "200px",
          preload: "auto", // 预加载
          controls: true, // 显示播放的控件
          multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
        },
        function () {
          this.on("play", () => {
            _this.is_play = true;
            _this.deductWatchCount()
          });
        }
      );

      this.getUserInfo();
      // this.times = setInterval(() => {
      //   if (this.is_play) {
      //     const ct = Math.round(this.player.currentTime());
      //     if (ct >= 30) {
      //       this.player.pause();
      //       this.$toast(this.$t("video.buy"));
      //       return;
      //     }
      //   }
      // }, 1000 * 2);
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    if (this.is_play) {
      this.is_play = false;
    }
    clearInterval(this.times);
  },
};
</script>

<style scoped lang="less">
/deep/ .van-tabs__nav {
  background: #fff;
}

/deep/ .van-nav-bar__title {
  color: #333 !important;
}

.van-nav-bar {
  background: #fff;
  border-bottom-width: 0;
}

.movie-video {
  height: 400px;
}

.video-js {
  width: 100%;
  height: 400px;
  font-size: 24px;
}

.btn {
  background-image: -webkit-linear-gradient(45deg, rgba(235, 96, 112, 0.875), #EC6272);
  background-image: linear-gradient(45deg, rgba(235, 96, 112, 0.875), #EC6272);
  display: block;
  margin: 28px 60px;
  font-size: 24px;
  color: #fff;
  height: 80px;
  border-radius: 40px;
  text-align: center;
  line-height: 1;
  position: relative;

  p:nth-child(1) {
    font-size: 22.4px;
    font-weight: bold;
  }

  p {
    font-size: 24px;
    padding-top: 8px;
  }

  .icon {
    width: 66px;
    height: 66px;
    border-radius: 100%;
    background: #ffffff;
    position: absolute;
    right: 12px;
    top: 6px;
  }
}

.videos {
  padding: 16px 20px 0 16px;

  .videoItem {
    width: 100%;
    margin-top: 8px;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    padding-bottom: 8px;
    border-bottom: 2px solid #fff;
    overflow: hidden;

    .img {
      width: 184px;
      height: 168px;

      img {
        /* height: 100%; */
        /* width: 100%; */
        height: 168px;
      }
    }

    .info {
      padding-left: 16px;

      h3 {
        color: #000;
        font-size: 30px;
        font-weight: 700;
        width: 560px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      p {
        color: #000;
        font-size: 28px;
      }
    }
  }
}

.movie-content {
  flex: 1;
  overflow-y: auto;
}

.movie-descript {
  width: 100%;
  /* height: 140px; */
  /* background-color: #fff; */
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
}

.movie-descript p {
  font-size: 30px;
  font-weight: 700;
  color: #000;
}

.movie-descript span {
  color: rgb(170, 45, 220);
  font-size: 0.8rem;
  background: rgb(242, 242, 245);
  padding: 10px;
  border-radius: 16px;
}

.movie-content .movie-body {
  margin: 0 auto;
}

::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}

.movie-content .movie-body .movie-title {
  box-sizing: content-box;
  height: 58px;
  line-height: 50px;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  padding: 16px;
  text-indent: 30px;
  min-width: 132px;
  background: url(data:image/png;base64,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) no-repeat;
  background-size: 162px 58px;
  background-position: 16px center;
}

.movie-content .movie-body .movie-title>div:first-child {
  width: 410px;
}

.movie-content .movie-body .movie-title>div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
}

.movie-content .movie-body .movie-title>div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 25px;
  margin-right: 10px;
}

abbr,
address,
article,
aside,
audio,
b,
blockquote,
body,
canvas,
caption,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
samp,
section,
small,
span,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}

.hotlist {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.hotlist div {
  position: relative;
  width: calc(50% - 10px);
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 20px;
}

.hotlist div img {
  width: 100%;
  height: 27vw;
}

.hotlist div div {
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, .4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 3vw;
  height: 8vw;
  border-radius: 16px;
}

.hotlist div div span {
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding-left: 20px;
}
</style>
